import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Alert from "@material-ui/lab/Alert";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Chip from "@material-ui/core/Chip";
import LocationDataService from "../../services/LocationService";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0.5),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: (props) => ({
    flexGrow: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "31.2ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    "& .MuiAlert-root": {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(1),
      },
    },
  }),
  small: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "29ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    textAlign: "center",
  },
  item: {
    height: "350px",
    alignItems: "center",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

function LocationForm() {
  const classes = useStyles();

  const [loc] = React.useState(
    JSON.parse(localStorage.getItem("loc")).id || ""
  );

  const [locations, setLocations] = useState([]);

  useEffect(() => {
    retrieveLocations();
  }, []);

  const retrieveLocations = () => {
    LocationDataService.getAll(loc)
      .then((response) => {
        setLocations(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setLocation({ ...location, [name]: value });
  };

  const [locationMessage, setLocationMessage] = useState("");
  const initialLocationState = {
    id: null,
    name: "",
    number: Math.floor(Math.random() * 1000 + 1),
  };

  const [location, setLocation] = useState(initialLocationState);
  const [submitted, setSubmitted] = useState(false);

  const saveLocation = () => {
    var data = {
      name: location.name,
      number: location.number,
    };

    LocationDataService.create(data)
      .then((response) => {
        setLocation({
          id: response.data.id,
          name: response.data.name,
          number: response.data.number,
        });
        setSubmitted(true);
        setLocationMessage(
          <Alert severity="success">Успешно добавихте локацията!</Alert>
        );
        retrieveLocations();
        setTimeout(() => {
          setLocationMessage(false);
        }, 5000);
        console.log(response.data);
      })
      .catch((e) => {
        setSubmitted(true);
        setLocationMessage(
          <Alert severity="error">Възникна грешка. Опитайте отново!</Alert>
        );
        retrieveLocations();
        setTimeout(() => {
          setLocationMessage(false);
        }, 5000);
        console.log(e);
      });
  };

  const newLocation = () => {
    setLocation(initialLocationState);
    setSubmitted(false);
  };

  // const handleDelete = chipToDelete => () => {
  // 	setLocation(locations => location.id !== chipToDelete.id)
  // }

  const handleDelete = (id) => {
    LocationDataService.remove(id)
      .then((response) => {
        setLocationMessage(
          <Alert severity="success">Успешно премахнахте локацията!</Alert>
        );
        console.log(response.data);
        retrieveLocations();
        // retrieveDeletedLocations();
        setTimeout(() => {
          setLocationMessage();
        }, 5000);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Card className={classes.item}>
      <AppBar position="static" elevation={0} color="primary">
        <Toolbar className="px-8">
          <Typography
            variant="subtitle1"
            color="inherit"
            className="flex-1 px-12"
          >
            Добави Локация
          </Typography>
        </Toolbar>
      </AppBar>
      {locationMessage}
      <CardContent>
        <div className="edit-form">
          <form className={classes.small}>
            <TextField
              required
              id="outlined-required name"
              label="Локация"
              variant="outlined"
              name="name"
              value={location.name}
              onChange={handleInputChange}
              size="small"
            />
            <Button onClick={saveLocation} variant="contained" color="primary">
              Добави
            </Button>
          </form>
        </div>
        <div className={classes.chips}>
          {locations.map((location) => (
            <Chip
              id={location.id}
              onDelete={() => handleDelete(location.id)}
              label={location.name}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default LocationForm;
